import type { ReactNode } from 'react'
import { StatusChip, type StatusPillTone } from '../Common'

type Tone = 'neutral' | 'success' | 'warning' | 'critical' | 'accent' | 'muted'

export type GhostBadgeProps = {
  tone?: Tone
  children: ReactNode
  icon?: ReactNode
  title?: string
}

const GHOST_TO_STATUS_TONE: Record<Tone, StatusPillTone> = {
  neutral: 'neutral',
  success: 'success',
  warning: 'warning',
  critical: 'danger',
  accent: 'info',
  muted: 'muted',
}

export const GhostBadge = ({ tone = 'neutral', children, icon, title }: GhostBadgeProps) => {
  return (
    <span className={`ghostBadge ghostBadge--${tone}`} title={title}>
      <StatusChip tone={GHOST_TO_STATUS_TONE[tone]} icon={icon}>
        {children}
      </StatusChip>
    </span>
  )
}
